import { render, staticRenderFns } from "./TAFooter-En.vue?vue&type=template&id=250c6d7f&scoped=true&"
import script from "./TAFooter-En.vue?vue&type=script&lang=js&"
export * from "./TAFooter-En.vue?vue&type=script&lang=js&"
import style0 from "./TAFooter-En.vue?vue&type=style&index=0&id=250c6d7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c6d7f",
  null
  
)

export default component.exports